import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-20 text-black" }


import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Brand } from '../../services/integration/enums';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroText',
  props: {
    title: {},
    subtitle: {}
  },
  setup(__props: any) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", {
      class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-bold text-brand-secondary' : 'font-extrabold text-gray-900', "text-3xl sm:text-5xl sm:leading-none sm:tracking-tight lg:text-6xl"])
    }, _toDisplayString(_ctx.title), 3),
    (_ctx.subtitle)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-medium ' : 'font-light text-gray-500 ', "sm:mt-2 max-w-2xl text-xl"])
        }, _toDisplayString(_ctx.subtitle), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})